export const apiConfig = {
  timeeApiCustomHeader: 'X-REQUESTED-BY-TIMEE-APP-API',
  timeeAdminApiCustomHeader: 'X-REQUESTED-BY-TIMEE-ADMIN-API',
  retryWaitMillSec: 300,
} as const;
